import { Badge, AppState } from "@/types";

export const ALL_BADGES: Badge[] = [
  // Welcome badge - immediate unlock
  { id: 'welcome', name: 'Welcome!', description: 'Welcome to your journey! Start logging activities to unlock more badges.', imageUrl: '', icon: '👋', rarity: 'common', target: 0, pointsThreshold: 0 },
  
  // Activity badges
  { id: 'first-activity', name: 'First Steps', description: 'Log your first activity of any type', imageUrl: '', icon: '🌟', rarity: 'common', target: 1, pointsThreshold: 0 },
  { id: 'first-set', name: 'First Set', description: 'Log your first Set activity', imageUrl: '', icon: '🎯', rarity: 'common', target: 1, pointsThreshold: 0 },
  { id: 'opening-master', name: 'Opening Master', description: 'Complete 10 Opening activities', imageUrl: '', icon: '🔓', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'closing-champion', name: 'Closing Champion', description: 'Complete 25 Closing activities', imageUrl: '', icon: '✅', rarity: 'epic', target: 25, pointsThreshold: 0 },
  { id: 'daily-warrior', name: 'Daily Warrior', description: 'Complete 5 Daily Quest activities', imageUrl: '', icon: '⚔️', rarity: 'rare', target: 5, pointsThreshold: 0 },
  
  // New activity badges for the new activities
  { id: 'networking-ninja', name: 'Networking Ninja', description: 'Complete 10 Referral activities', imageUrl: '', icon: '🤝', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'client-whisperer', name: 'Client Whisperer', description: 'Complete 15 Client Servicing activities', imageUrl: '', icon: '🎧', rarity: 'rare', target: 15, pointsThreshold: 0 },
  { id: 'referral-rockstar', name: 'Referral Rockstar', description: 'Complete 25 Referral activities', imageUrl: '', icon: '⭐', rarity: 'epic', target: 25, pointsThreshold: 0 },
  { id: 'service-superstar', name: 'Service Superstar', description: 'Complete 30 Client Servicing activities', imageUrl: '', icon: '🌟', rarity: 'epic', target: 30, pointsThreshold: 0 },
  
  // Streak badges
  { id: 'streak-3', name: '3-Day Streak', description: 'Maintain a 3-day activity streak', imageUrl: '', icon: '🔥', rarity: 'common', target: 3, pointsThreshold: 0 },
  { id: 'week-warrior', name: 'Week Warrior', description: 'Maintain a 7-day activity streak', imageUrl: '', icon: '💪', rarity: 'rare', target: 7, pointsThreshold: 0 },
  { id: 'month-champion', name: 'Month Champion', description: 'Maintain a 30-day activity streak', imageUrl: '', icon: '🏅', rarity: 'legendary', target: 30, pointsThreshold: 0 },
  { id: 'streak-beast', name: 'Streak Beast', description: 'Maintain a 50-day activity streak', imageUrl: '', icon: '🦁', rarity: 'legendary', target: 50, pointsThreshold: 0 },
  
  // Point badges
  { id: 'first-25', name: 'Getting Started', description: 'Earn your first 25 points', imageUrl: '', icon: '🌱', rarity: 'common', target: 25, pointsThreshold: 25 },
  { id: 'half-century', name: 'Half Century', description: 'Earn 50 total points', imageUrl: '', icon: '💯', rarity: 'common', target: 50, pointsThreshold: 50 },
  { id: 'century-club', name: 'Century Club', description: 'Earn 100 total points', imageUrl: '', icon: '🌟', rarity: 'rare', target: 100, pointsThreshold: 100 },
  { id: 'high-achiever', name: 'High Achiever', description: 'Earn 250 total points', imageUrl: '', icon: '⭐', rarity: 'rare', target: 250, pointsThreshold: 250 },
  { id: 'point-master', name: 'Point Master', description: 'Earn 500 total points', imageUrl: '', icon: '💎', rarity: 'epic', target: 500, pointsThreshold: 500 },
  { id: 'legend', name: 'Legend', description: 'Earn 1000 total points', imageUrl: '', icon: '👑', rarity: 'legendary', target: 1000, pointsThreshold: 1000 },
  { id: 'elite-performer', name: 'Elite Performer', description: 'Earn 2000 total points', imageUrl: '', icon: '💫', rarity: 'legendary', target: 2000, pointsThreshold: 2000 },
  
  // Weekly badges
  { id: 'goal-crusher', name: 'Goal Crusher', description: 'Exceed weekly goal by 50%', imageUrl: '', icon: '⚡', rarity: 'rare', target: 1, pointsThreshold: 0 },
  { id: 'overachiever', name: 'Overachiever', description: 'Double your weekly goal', imageUrl: '', icon: '🚀', rarity: 'epic', target: 1, pointsThreshold: 0 },
  { id: 'weekly-champion', name: 'Weekly Champion', description: 'Achieve weekly goal 10 times', imageUrl: '', icon: '🏆', rarity: 'epic', target: 10, pointsThreshold: 0 },
  { id: 'consistency-king', name: 'Consistency King', description: 'Meet weekly goal 5 weeks in a row', imageUrl: '', icon: '👑', rarity: 'legendary', target: 5, pointsThreshold: 0 },
  
  // Consulting-themed professional badges
  { id: 'junior-consultant', name: 'Junior Consultant', description: 'Complete 50 total activities', imageUrl: '', icon: '💼', rarity: 'common', target: 50, pointsThreshold: 0 },
  { id: 'senior-consultant', name: 'Senior Consultant', description: 'Complete 150 total activities', imageUrl: '', icon: '📊', rarity: 'rare', target: 150, pointsThreshold: 0 },
  { id: 'principal-consultant', name: 'Principal Consultant', description: 'Complete 300 total activities', imageUrl: '', icon: '🎩', rarity: 'epic', target: 300, pointsThreshold: 0 },
  { id: 'partner-level', name: 'Partner Level', description: 'Complete 500 total activities', imageUrl: '', icon: '💎', rarity: 'legendary', target: 500, pointsThreshold: 0 },
  
  // Performance excellence badges
  { id: 'deal-maker', name: 'Deal Maker', description: 'Close 10 deals (Closed activities)', imageUrl: '', icon: '🤝', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'sales-machine', name: 'Sales Machine', description: 'Close 25 deals (Closed activities)', imageUrl: '', icon: '💰', rarity: 'epic', target: 25, pointsThreshold: 0 },
  { id: 'revenue-generator', name: 'Revenue Generator', description: 'Close 50 deals (Closed activities)', imageUrl: '', icon: '💸', rarity: 'legendary', target: 50, pointsThreshold: 0 },
  { id: 'opportunity-creator', name: 'Opportunity Creator', description: 'Complete 50 Opening activities', imageUrl: '', icon: '🔑', rarity: 'epic', target: 50, pointsThreshold: 0 },
  
  // Social badges
  { id: 'socialite', name: 'Socialite', description: 'Like 10 activities from other users', imageUrl: '', icon: '❤️', rarity: 'common', target: 10, pointsThreshold: 0 },
  { id: 'commentator', name: 'Commentator', description: 'Leave 5 comments on activities', imageUrl: '', icon: '💬', rarity: 'common', target: 5, pointsThreshold: 0 },
  { id: 'team-player', name: 'Team Player', description: 'Complete 10 Hangout activities', imageUrl: '', icon: '🤝', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'culture-champion', name: 'Culture Champion', description: 'Complete 25 Hangout activities', imageUrl: '', icon: '🎉', rarity: 'epic', target: 25, pointsThreshold: 0 },
  
  // Variety badges
  { id: 'jack-of-all-trades', name: 'Jack of All Trades', description: 'Log at least one of each activity type', imageUrl: '', icon: '🎭', rarity: 'rare', target: 1, pointsThreshold: 0 },
  { id: 'story-teller', name: 'Story Teller', description: 'Complete 15 Story activities', imageUrl: '', icon: '📚', rarity: 'rare', target: 15, pointsThreshold: 0 },
  { id: 'role-master', name: 'Role Master', description: 'Complete 20 Roleplay activities', imageUrl: '', icon: '🎪', rarity: 'rare', target: 20, pointsThreshold: 0 },
  { id: 'diversified-performer', name: 'Diversified Performer', description: 'Complete 5+ of each activity type', imageUrl: '', icon: '🌈', rarity: 'epic', target: 1, pointsThreshold: 0 },
  
  // Work-life balance badges
  { id: 'early-bird', name: 'Early Bird', description: 'Log 5 activities before 9 AM', imageUrl: '', icon: '🌅', rarity: 'common', target: 5, pointsThreshold: 0 },
  { id: 'night-owl', name: 'Night Owl', description: 'Log 5 activities after 9 PM', imageUrl: '', icon: '🦉', rarity: 'common', target: 5, pointsThreshold: 0 },
  { id: 'weekend-warrior', name: 'Weekend Warrior', description: 'Log 10 activities on weekends', imageUrl: '', icon: '🏖️', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'work-life-guru', name: 'Work-Life Guru', description: 'Maintain balanced activity across all days', imageUrl: '', icon: '⚖️', rarity: 'epic', target: 1, pointsThreshold: 0 },
  
  // Intensity badges
  { id: 'power-hour', name: 'Power Hour', description: 'Log 5 activities in one hour', imageUrl: '', icon: '⚡', rarity: 'rare', target: 5, pointsThreshold: 0 },
  { id: 'grind-master', name: 'Grind Master', description: 'Log 20 activities in a single day', imageUrl: '', icon: '⚙️', rarity: 'epic', target: 20, pointsThreshold: 0 },
  { id: 'productivity-machine', name: 'Productivity Machine', description: 'Log 30 activities in a single day', imageUrl: '', icon: '🤖', rarity: 'legendary', target: 30, pointsThreshold: 0 },
  
  // Client-focused badges
  { id: 'client-advocate', name: 'Client Advocate', description: 'Complete 20 Client Servicing activities', imageUrl: '', icon: '🛡️', rarity: 'rare', target: 20, pointsThreshold: 0 },
  { id: 'relationship-builder', name: 'Relationship Builder', description: 'Complete 15 combined Referral and Client Servicing', imageUrl: '', icon: '🤗', rarity: 'rare', target: 15, pointsThreshold: 0 },
  { id: 'growth-catalyst', name: 'Growth Catalyst', description: 'Complete 50 combined Referral and Client Servicing', imageUrl: '', icon: '📈', rarity: 'epic', target: 50, pointsThreshold: 0 },
  
  // Pet badges
  { id: 'pet-parent', name: 'Pet Parent', description: 'Create your first virtual pet', imageUrl: '', icon: '🐣', rarity: 'common', target: 1, pointsThreshold: 0 },
  { id: 'pet-caretaker', name: 'Pet Caretaker', description: 'Feed your pet 25 times', imageUrl: '', icon: '🍼', rarity: 'rare', target: 25, pointsThreshold: 0 },
  { id: 'pet-trainer', name: 'Pet Trainer', description: 'Play with your pet 15 times', imageUrl: '', icon: '🎾', rarity: 'rare', target: 15, pointsThreshold: 0 },
  { id: 'evolution-expert', name: 'Evolution Expert', description: 'Evolve your pet to Adult stage', imageUrl: '', icon: '🦋', rarity: 'epic', target: 1, pointsThreshold: 0 },
  { id: 'fashion-designer', name: 'Fashion Designer', description: 'Customize your pet with 5 different outfits', imageUrl: '', icon: '👗', rarity: 'rare', target: 5, pointsThreshold: 0 },
  { id: 'pet-whisperer', name: 'Pet Whisperer', description: 'Reach maximum happiness with your pet', imageUrl: '', icon: '😊', rarity: 'epic', target: 1, pointsThreshold: 0 },
  
  // Special achievement badges
  { id: 'speed-demon', name: 'Speed Demon', description: 'Log 10 activities in under 10 minutes', imageUrl: '', icon: '💨', rarity: 'epic', target: 10, pointsThreshold: 0 },
  { id: 'perfectionist', name: 'Perfectionist', description: 'Achieve weekly goal 5 weeks in a row', imageUrl: '', icon: '✨', rarity: 'legendary', target: 5, pointsThreshold: 0 },
  { id: 'comeback-kid', name: 'Comeback Kid', description: 'Restart streak after losing a 7+ day streak', imageUrl: '', icon: '🔄', rarity: 'rare', target: 1, pointsThreshold: 0 },
  { id: 'milestone-hunter', name: 'Milestone Hunter', description: 'Unlock 10 different badges', imageUrl: '', icon: '🏆', rarity: 'epic', target: 10, pointsThreshold: 0 },
  { id: 'achievement-collector', name: 'Achievement Collector', description: 'Unlock 25 different badges', imageUrl: '', icon: '🎖️', rarity: 'legendary', target: 25, pointsThreshold: 0 },
  
  // Innovation and learning badges
  { id: 'innovation-driver', name: 'Innovation Driver', description: 'Try all activity types in one week', imageUrl: '', icon: '💡', rarity: 'rare', target: 1, pointsThreshold: 0 },
  { id: 'knowledge-seeker', name: 'Knowledge Seeker', description: 'Complete 30 Story activities', imageUrl: '', icon: '🎓', rarity: 'epic', target: 30, pointsThreshold: 0 },
  { id: 'skill-builder', name: 'Skill Builder', description: 'Complete 40 Roleplay activities', imageUrl: '', icon: '🎯', rarity: 'epic', target: 40, pointsThreshold: 0 },
  
  // Time-based badges
  { id: 'first-week', name: 'First Week Complete', description: 'Use the app for 7 consecutive days', imageUrl: '', icon: '📅', rarity: 'common', target: 7, pointsThreshold: 0 },
  { id: 'first-month', name: 'Monthly Veteran', description: 'Use the app for 30 days', imageUrl: '', icon: '🗓️', rarity: 'rare', target: 30, pointsThreshold: 0 },
  { id: 'quarterly-champion', name: 'Quarterly Champion', description: 'Use the app for 90 days', imageUrl: '', icon: '📈', rarity: 'epic', target: 90, pointsThreshold: 0 },
  { id: 'loyal-user', name: 'Loyal User', description: 'Use the app for 365 days', imageUrl: '', icon: '💝', rarity: 'legendary', target: 365, pointsThreshold: 0 },
  
  // Challenge badges
  { id: 'challenge-starter', name: 'Challenge Starter', description: 'Complete your first challenge', imageUrl: '', icon: '🎯', rarity: 'common', target: 1, pointsThreshold: 0 },
  { id: 'challenge-master', name: 'Challenge Master', description: 'Complete 10 challenges', imageUrl: '', icon: '🏅', rarity: 'rare', target: 10, pointsThreshold: 0 },
  { id: 'challenge-legend', name: 'Challenge Legend', description: 'Complete 25 challenges', imageUrl: '', icon: '🏆', rarity: 'epic', target: 25, pointsThreshold: 0 },
];

export function checkBadgeProgress(badge: Badge, state: AppState): Badge {
  let progress = 0;
  let isUnlocked = false;
  
  const totalActivities = Object.values(state.activityCounts || {}).reduce((sum, count) => sum + count, 0);
  
  // Debug logging for badge checking
  if (badge.id === 'welcome' || badge.id === 'first-activity' || badge.id === 'first-25') {
    console.log(`🏅 Checking badge: ${badge.name}`, {
      badgeId: badge.id,
      target: badge.target,
      pointsThreshold: badge.pointsThreshold,
      totalPoints: state.totalPoints,
      totalActivities,
      currentProgress: progress
    });
  }

  switch (badge.id) {
    // Welcome badge - always unlocked for authenticated users
    case 'welcome':
      progress = state.isAuthenticated ? 1 : 0;
      isUnlocked = state.isAuthenticated;
      break;
      
    // First activity badge - any activity unlocks this
    case 'first-activity':
      progress = totalActivities;
      break;
      
    // Activity badges
    case 'first-set':
      progress = state.activityCounts['Set'] || 0;
      break;
    case 'opening-master':
    case 'opportunity-creator':
      progress = state.activityCounts['Opening'] || 0;
      break;
    case 'closing-champion':
      progress = (state.activityCounts['Closed'] || 0) + (state.activityCounts['Closing'] || 0);
      break;
    case 'daily-warrior':
      progress = state.activityCounts['Daily Quest'] || 0;
      break;
    case 'team-player':
    case 'culture-champion':
      progress = state.activityCounts['Hangout'] || 0;
      break;
    case 'story-teller':
    case 'knowledge-seeker':
      progress = state.activityCounts['Story'] || 0;
      break;
    case 'role-master':
    case 'skill-builder':
      progress = state.activityCounts['Roleplay'] || 0;
      break;
    case 'networking-ninja':
    case 'referral-rockstar':
      progress = state.activityCounts['Referral'] || 0;
      break;
    case 'client-whisperer':
    case 'service-superstar':
    case 'client-advocate':
      progress = state.activityCounts['Client Servicing'] || 0;
      break;
    case 'deal-maker':
    case 'sales-machine':
    case 'revenue-generator':
      progress = state.activityCounts['Closed'] || 0;
      break;
    case 'relationship-builder':
      progress = (state.activityCounts['Referral'] || 0) + (state.activityCounts['Client Servicing'] || 0);
      break;
    case 'growth-catalyst':
      progress = (state.activityCounts['Referral'] || 0) + (state.activityCounts['Client Servicing'] || 0);
      break;
      
    // Professional level badges
    case 'junior-consultant':
    case 'senior-consultant':
    case 'principal-consultant':
    case 'partner-level':
      progress = totalActivities;
      break;
      
    // Streak badges
    case 'streak-3':
    case 'week-warrior':
    case 'month-champion':
    case 'streak-beast':
      progress = state.streak;
      break;
      
    // Point badges
    case 'first-25':
    case 'half-century':
    case 'century-club':
    case 'high-achiever':
    case 'point-master':
    case 'legend':
    case 'elite-performer':
      progress = state.totalPoints;
      break;
      
    // Weekly badges
    case 'goal-crusher':
      progress = state.currentWeekPoints >= (state.weeklyGoal * 1.5) ? 1 : 0;
      break;
    case 'overachiever':
      progress = state.currentWeekPoints >= (state.weeklyGoal * 2) ? 1 : 0;
      break;
    case 'weekly-champion':
      // Use a placeholder value until we add weekly goals tracking
      progress = Math.floor((state.totalPoints || 0) / 50); // Rough estimate based on total activity
      break;
    case 'consistency-king':
    case 'perfectionist':
      progress = state.weeklyGoalStreak || 0;
      break;
      
    // Social badges (placeholder - would need actual social tracking)
    case 'socialite':
      progress = 0; // Would track likes given
      break;
    case 'commentator':
      progress = 0; // Would track comments made
      break;
      
    // Variety badges
    case 'jack-of-all-trades':
      const activityTypes = ['Set', 'Opening', 'Closing', 'Closed', 'Hangout', 'Story', 'Daily Quest', 'Roleplay', 'Referral', 'Client Servicing'];
      progress = activityTypes.filter(type => (state.activityCounts[type] || 0) > 0).length >= 10 ? 1 : 0;
      break;
    case 'diversified-performer':
      const allTypes = ['Set', 'Opening', 'Closing', 'Closed', 'Hangout', 'Story', 'Daily Quest', 'Roleplay', 'Referral', 'Client Servicing'];
      progress = allTypes.filter(type => (state.activityCounts[type] || 0) >= 5).length >= 10 ? 1 : 0;
      break;
    case 'innovation-driver':
      progress = 0; // Would need weekly activity type tracking
      break;
      
    // Time-based badges (placeholder - would need actual time tracking)
    case 'early-bird':
    case 'night-owl':
    case 'weekend-warrior':
    case 'work-life-guru':
      progress = 0; // Would need time-based activity tracking
      break;
    case 'power-hour':
      progress = 0; // Would need hour-based tracking
      break;
    case 'grind-master':
    case 'productivity-machine':
      progress = state.activitiesLoggedToday >= badge.target ? 1 : 0;
      break;
      
    // Pet badges
    case 'pet-parent':
      progress = state.virtualPet ? 1 : 0;
      break;
    case 'pet-caretaker':
    case 'pet-trainer':
    case 'evolution-expert':
    case 'fashion-designer':
    case 'pet-whisperer':
      progress = 0; // Would need pet interaction tracking
      break;
      
    // Special badges
    case 'speed-demon':
    case 'comeback-kid':
      progress = 0; // Would need specialized tracking
      break;
    case 'milestone-hunter':
      const unlockedBadges = (state.badges || []).filter(b => b.unlockedAt).length;
      progress = unlockedBadges;
      break;
    case 'achievement-collector':
      const totalUnlockedBadges = (state.badges || []).filter(b => b.unlockedAt).length;
      progress = totalUnlockedBadges;
      break;
      
    // Challenge badges
    case 'challenge-starter':
    case 'challenge-master':
    case 'challenge-legend':
      // Use completed activities as placeholder for challenges
      progress = Math.floor((state.totalPoints || 0) / 25); // Rough estimate based on activity completion
      break;
      
    // Time-based usage badges
    case 'first-week':
    case 'first-month':
    case 'quarterly-champion':
    case 'loyal-user':
      progress = 0; // Would need login day tracking
      break;
  }
  
  // Check if badge should be unlocked
  if (!isUnlocked && badge.pointsThreshold > 0) {
    isUnlocked = (state.totalPoints || 0) >= badge.pointsThreshold;
  } else if (!isUnlocked) {
    isUnlocked = progress >= badge.target;
  }

  // Debug logging for unlock status
  if (badge.id === 'welcome' || badge.id === 'first-activity' || badge.id === 'first-25') {
    console.log(`🏅 Badge ${badge.name} status:`, {
      progress: Math.min(progress, badge.target),
      target: badge.target,
      isUnlocked,
      pointsThreshold: badge.pointsThreshold,
      totalPoints: state.totalPoints
    });
  }

  const result = {
    ...badge,
    progress: Math.min(progress, badge.target),
    unlockedAt: isUnlocked ? (badge.unlockedAt || new Date()) : undefined,
  };

  return result;
};

export const getAllBadges = (state: AppState): Badge[] => {
  if (!state || !state.badges) {
    return ALL_BADGES.map(badge => checkBadgeProgress(badge, state || {} as AppState));
  }
  return ALL_BADGES.map(badge => {
    const existingBadge = state.badges.find(b => b.id === badge.id);
    return existingBadge || checkBadgeProgress(badge, state);
  });
};
